import { generatePath } from 'react-router';

const routeTokenParam = ':token/';
const routeClientParam = ':clientId/';

export type ClientRouteParam = {
	clientId: number;
};

const PATHS = {
	root: '/',
	profile: '/profile',
	charts: '/charts',
	login: '/login',
	reset_pass: `/login/reset-password/${routeTokenParam}`,
	recovery_pass: '/login/password-recovery',
	new_blank: '/new-blank',
	admin: '/admin',
	blank_id: `/new-blank/${routeClientParam}`,
	registration: `/registration`,
	registration_confirm: `/registration/${routeTokenParam}`,
	confirm_email: `/registration/confirm-email/${routeTokenParam}`,
	client_blank: `/client-blank/${routeClientParam}`,
	consent: `/consent/${routeTokenParam}`,
};

export const routes = {
	root: {
		path: PATHS.root,
		getPath: () => generatePath(PATHS.root),
	},

	blank: {
		path: PATHS.root,
	},

	new_blank: {
		path: PATHS.new_blank,
	},

	profile: {
		path: PATHS.profile,
	},

	charts: {
		path: PATHS.charts,
	},

	login: {
		path: PATHS.login,
	},

	login_auth: {
		path: PATHS.login,
	},

	recovery_pass: {
		path: PATHS.recovery_pass,
	},

	reset_pass: {
		path: PATHS.reset_pass,
	},

	registration: {
		path: PATHS.registration,
	},

	registration_confirm: {
		path: PATHS.registration_confirm,
	},

	confirm_email: {
		path: PATHS.confirm_email,
	},

	admin: {
		path: PATHS.admin,
	},

	//TODO разобраться с blank и blank_id и new_blank (при редактировании не хочется видеть в url new-blank)

	blank_id: {
		path: PATHS.blank_id,
		getPath: ({ clientId }: ClientRouteParam) => generatePath(PATHS.blank_id, { clientId }),
	},

	client_blank: {
		path: PATHS.client_blank,
		getPath: ({ clientId }: ClientRouteParam) => generatePath(PATHS.client_blank, { clientId }),
	},

	consent: {
		path: PATHS.consent,
	},
};
